export default "__VITE_ASSET__5c610fd7__"